import { render, staticRenderFns } from "./WizardStepWidget.vue?vue&type=template&id=5c8b5314&scoped=true"
import script from "./WizardStepWidget.vue?vue&type=script&lang=js"
export * from "./WizardStepWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8b5314",
  null
  
)

export default component.exports